import React, { createContext, useReducer, useContext } from 'react'

import { identityActions, identityInitialState } from './identity'
import { alertsActions, alertsInitialState } from './alerts'
import { avatarActions, avatarInitialState } from './avatar'
import {
  businessTypesActions,
  businessTypesInitialState,
} from './businessTypes'
import { contactTypesActions, contactTypesInitialState } from './contactTypes'
import { customFieldsActions, customFieldsInitialState } from './customFields'
import { productsActions, productsInitialState } from './products'
import { pipelinesActions, pipelinesInitialState } from './pipelines'
import {
  companyConfigActions,
  companyConfigInitialState,
} from './companyConfig'
import { nextStepsActions, nextStepsInitialState } from './nextSteps'
import { companyActions, companyInitialState } from './company'
import { taskModalsActions, taskModalsInitialState } from './tasks'

const Actions = {
  ...identityActions,
  ...alertsActions,
  ...companyConfigActions,
  ...avatarActions,
  ...businessTypesActions,
  ...contactTypesActions,
  ...customFieldsActions,
  ...productsActions,
  ...pipelinesActions,
  ...companyActions,
  ...nextStepsActions,
  ...taskModalsActions,
}
const initialState = {
  ...identityInitialState,
  ...alertsInitialState,
  ...companyConfigInitialState,
  ...avatarInitialState,
  ...businessTypesInitialState,
  ...contactTypesInitialState,
  ...customFieldsInitialState,
  ...productsInitialState,
  ...pipelinesInitialState,
  ...nextStepsInitialState,
  ...companyInitialState,
  ...taskModalsInitialState,
}

const StoreContext = createContext(initialState)

const reducer = (state, action) => {
  const act = Actions[action.type]
  const update = act(state, action)
  return { ...state, ...update }
}

export const StoreProvider = ({ children }) => {
  const [state, dispatch] = useReducer(reducer, initialState)
  return (
    <StoreContext.Provider value={{ state, dispatch }}>
      {children}
    </StoreContext.Provider>
  )
}

export const useStore = () => {
  const { state, dispatch } = useContext(StoreContext)
  return { state, dispatch }
}
